module.exports = __webpack_public_path__ + "img/avatar4.f69b94c6.png";